import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  Workspace,
  WorkspacePayload,
  WorkspaceUpdatePayload,
} from '../models/workspace.model';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceApiService {
  constructor(private http: HttpClient) {}

  /**
   * Fetches all workspaces that user has access to
   */
  getAllWorkspaces(
    accountId: string,
    includeChannels = true,
  ): Observable<Workspace[]> {
    const query = includeChannels ? '?includeChannels' : '';
    return this.http.get<Workspace[]>(`/workspaces/${accountId}${query}`);
  }

  /**
   * Creates new worskpace for account
   */
  createWorkspace(payload: WorkspacePayload): Observable<Workspace> {
    return this.http.post<Workspace>(`/workspace?includeChannels`, payload);
  }

  /**
   * Deletes worskpace
   */
  deleteWorkspace(workspaceId: string): Observable<Workspace> {
    return this.http.delete<Workspace>(`/workspace/${workspaceId}`);
  }

  /**
   * Updates workspace
   */
  updateWorkspace(
    workspaceId: string,
    payload: WorkspaceUpdatePayload,
  ): Observable<Workspace> {
    return this.http.patch<Workspace>(`/workspace/${workspaceId}`, payload);
  }
}
